import script from "./InputField.vue?vue&type=script&setup=true&lang=js"
export * from "./InputField.vue?vue&type=script&setup=true&lang=js"

import "./InputField.vue?vue&type=style&index=0&id=877e1d92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-877e1d92"]])

export default __exports__